import {countryArr} from "@/assets/js/country";
import {nationArr} from "@/assets/js/nation";
import {languageArr} from "@/assets/js/language";
import {info_view} from "@/api/training_student/vita";
import {storageData} from "@/assets/js/storage";
const HOST = process.env.VUE_APP_URL;
export default {
  data() {
    const gender = [
      {
        key: "男",
        val: "Male"
      },
      {
        key: "女",
        val: "Female"
      },
    ];
    return {
      gender,
      countryArr,
      nationArr,
      languageArr,
      stuInfo: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      info_view({})
        .then(({data}) => {
          if (Number(data.status) === 0) {
            // console.log(data);
            let {language_list, academic_data, experience_data, experience_data_not, playing_data, studentSingnInfo,auditData} = data.result;
            // 护照头像，身份证正反面
            studentSingnInfo.profile_picture && (this.photo = HOST + studentSingnInfo.profile_picture);
            if (studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.$set(this.vitaForm,'family_name_spell',studentSingnInfo.family_name_spell);
              this.switch_pinyin=true;
            }
            if(studentSingnInfo.family_name_spell && studentSingnInfo.given_name_spell){
              this.spell_both=true;
            }
            if(studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.spell_family=true;
            }
            if(!studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.spell_none=true;
            }
            this.id_type=studentSingnInfo.id_type
            const userInfo = storageData.getUserInfo();
            if (auditData.length>0)this.auditData=auditData;
            if (studentSingnInfo.student_information ==='Active'){
                this.showMyResume=true;
            }
            if (studentSingnInfo.id_card_photo_front && (userInfo.member_type==="expireStudent" || userInfo.member_type==="expFive")){
              this.cart_front_not_change=true;
            }
            if (studentSingnInfo.id_card_photo_verso &&(userInfo.member_type==="expireStudent" || userInfo.member_type==="expFive")){
              this.cart_back_not_change=true;
            }
            if (studentSingnInfo.profile_picture && (userInfo.member_type==="expireStudent" || userInfo.member_type==="expFive")){
              this.pro_not_change=true;
            }
            if (!studentSingnInfo.info_status ||studentSingnInfo.info_status==='refused' || studentSingnInfo.student_information==='verify'){
              this.not_allow_change=false;
            }else{
              const {profile_picture,id_card_photo_verso,id_card_photo_front,family_name_spell,given_name_spell,email_address}=studentSingnInfo;
              if (!profile_picture) this.picture_not_allow=false;
              if (!id_card_photo_verso) this.verso_not_allow=false;
              if (!id_card_photo_front) this.front_not_allow=false;
              if (!family_name_spell) this.name_family_not_allow=false;
              if (!given_name_spell) this.name_given_not_allow=false;
              if (!email_address) this.email_address_not_allow=false;
            }
            studentSingnInfo.id_card_photo_front && (this.cardFront = HOST + studentSingnInfo.id_card_photo_front);
            studentSingnInfo.id_card_photo_verso && (this.cardBack = HOST + studentSingnInfo.id_card_photo_verso);
            // 外语
            language_list.length && this.$set(this.vitaForm, "language_row", language_list);
            let english_file_list = []
            if(studentSingnInfo.english_file && studentSingnInfo.english_file_name){
              english_file_list.push({
                name: studentSingnInfo.english_file_name,
                url: studentSingnInfo.english_file,
              })
              this.vitaForm.english_file_list = english_file_list;
            }
            
            // 公用临时数组
            let tempArr = [];
            // 教育经历
            let academic_qualification = [];
            if (academic_data.length) {
              academic_qualification = academic_data.map((item) => {
                if(item.academic_end_date){
                  item.zhijin="N";
                }
                if(item.academic_start_date && item.academic_end_date) {
                  tempArr = [new Date(item.academic_start_date), new Date(item.academic_end_date)];
                } else {
                  tempArr = [];
                }
                const { work_certificate, work_certificate_title } = item;
                let work_certificate_list = []
                if(work_certificate && work_certificate_title) {
                  work_certificate_list.push({
                    name: work_certificate_title,
                    url: work_certificate,
                  })
                }
                return {
                  ...item,
                  time: tempArr,
                  work_certificate_list: work_certificate_list
                };
              });
            }
            // 执教经历
            let coaching_Experience = [];
            if (experience_data.length) {
              coaching_Experience = experience_data.map((item) => {
                if(item.coach_end_date){
                  item.zhijin="N";
                }
                if(item.coach_start_date && item.coach_end_date) {
                  tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                } else {
                  tempArr = [];
                }
                const { work_certificate, work_certificate_title } = item;
                let work_certificate_list = []
                if(work_certificate && work_certificate_title) {
                  work_certificate_list.push({
                    name: work_certificate_title,
                    url: work_certificate,
                  })
                }
                return {
                  ...item,
                  time: tempArr,
                  work_certificate_list: work_certificate_list
                };
              });
            }
            // 其他工作经历
            let coaching_Experience_not = [];
            if (experience_data_not.length) {
              coaching_Experience_not = experience_data_not.map((item) => {
                if(item.coach_end_date){
                  item.zhijin="N";
                }
                if(item.coach_start_date && item.coach_end_date) {
                  tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                } else {
                  tempArr = [];
                }
                const { work_certificate, work_certificate_title } = item;
                let work_certificate_list = []
                if(work_certificate && work_certificate_title) {
                  work_certificate_list.push({
                    name: work_certificate_title,
                    url: work_certificate,
                  })
                }
                return {
                  ...item,
                  time: tempArr,
                  work_certificate_list: work_certificate_list
                };
              });
            }
            // 运动经历
            let playing_experience = [];
            if (playing_data.length) {
              playing_experience = playing_data.map((item) => {
                if(item.play_end_date){
                  item.zhijin="N";
                }
                if(item.play_start_date && item.play_end_date) {
                  tempArr = [new Date(item.play_start_date), new Date(item.play_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }
            let mixinObj = {
              academic_qualification,
              // coaching_qualification,
              coaching_Experience,
              coaching_Experience_not,
              playing_experience
            };
            let {entries} = Object;
            for (let [key, value] of entries(mixinObj)) {
              if (value.length === 0) {
                delete mixinObj[key];
              }
            }
            // 学员信息
            // const birthDay = studentSingnInfo.id_number.length == 18
            //   ? studentSingnInfo.id_number.substr(6, 4) + "-" + studentSingnInfo.id_number.substr(10, 2) + "-" + studentSingnInfo.id_number.substr(12, 2)
            //   : "--";
            const birthDay = studentSingnInfo.birthday
            if(!birthDay){this.canChangeBirthday=true}
            this.noEdit = {
              gender: studentSingnInfo.gender,
              phone: studentSingnInfo.mobile_phone,
              idNum: studentSingnInfo.id_number,
              org_abbreviation: studentSingnInfo.org_abbreviation,
              birthDay,
            };

            this.vitaForm = {
              ...this.vitaForm,
              birthday:birthDay ? birthDay : '',
              ...studentSingnInfo,
              ...mixinObj,
            };
            // is_coach_experience_not
            if(this.vitaForm.is_coach_experience_not === 0 || this.vitaForm.is_coach_experience_not === '0') {
              this.isCoachExperienceNotExit = false
            } else {
              this.isCoachExperienceNotExit = true
            }
            if(this.vitaForm.coach_experience === '无') {
              this.isCoachExperienceExit = false;
              this.vitaForm.coach_experience = '无'
            } else {
              if(this.vitaForm.coach_experience) {
                  try {
                    this.vitaForm.coach_experience = JSON.parse(this.vitaForm.coach_experience)
                  } catch( err ) {
                    console.log('JSON parse function is error for vitaForm.take_place:', this.vitaForm.coach_experience)
                    this.vitaForm.coach_experience = [];
                  }
                }
            };
            if(this.vitaForm.take_place === '无') {
              this.isTackPalceExit = false;
              this.vitaForm.take_place = '无'
            } else {
                if(this.vitaForm.take_place) {
                  try {
                    this.vitaForm.take_place =  JSON.parse(this.vitaForm.take_place)
                  } catch( err ) {
                    console.log('JSON parse function is error for vitaForm.take_place:', this.vitaForm.take_place)
                    this.vitaForm.take_place = [];
                  }
                }
            };
            if(this.vitaForm.sport_experience_new === '无足球运动经历') {
              this.isSportExperienceExit = false;
              this.vitaForm.sport_experience_new = '无足球运动经历'
            } ;
            // this.vitaForm.coach_experience = this.vitaForm.coach_experience ? JSON.parse(this.vitaForm.coach_experience) : '';
            // this.vitaForm.take_place = this.vitaForm.take_place ? JSON.parse(this.vitaForm.take_place) : '';
            // this.vitaForm.sport_experience = this.vitaForm.sport_experience ? JSON.parse(this.vitaForm.sport_experience) : '';
            this.isLoading = false;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  }
}
